<template>
	<div
		class="dropdown d-inline-block"
		v-click-outside="close"
		@keydown.esc="closeOnEscape"
	>
		<div class="dropdown-button" ref="button" @click="toggle()">
			<slot name="toggle">
				<Button type="tertiary" class="btn-icon">
					<Icon :icon="['far', 'ellipsis-v']" fixed-width></Icon>
				</Button>
			</slot>
		</div>
		<transition name="dropdown">
			<div
				ref="menu"
				class="mt-2 dropdown-menu"
				:class="{
					show: isOpen,
					'dropdown-menu-limit': limit
				}"
				aria-labelledby="dropdownMenuButton"
				@click="dropdownItemClicked"
			>
				<slot :toggle="toggle"></slot>
			</div>
		</transition>
		<transition name="dropdown-backdrop">
			<div v-if="isOpen" class="dropdown-backdrop" @click="close()"></div>
		</transition>
	</div>
</template>
<script>
import Button from '~/components/ui/common/Button'
import { createPopper } from '@popperjs/core'
import Icon from '~/components/ui/common/Icon'

export default {
	components: {
		Button,
		Icon
	},
	props: {
		align: {
			type: String,
			default: 'bottom-start'
		},

		limit: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isOpen: false,
			popper: null
		}
	},
	mounted() {
		window.addEventListener('resize', this.syncPopper)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.syncPopper)
		this.destroyPopper()
	},
	deactivated() {
		this.close()
		this.destroyPopper()
	},
	methods: {
		syncPopper() {
			// Mobile menus use the fixed viewport layout supplied by the shared stylesheet.
			if (
				this._isDestroyed ||
				this._inactive ||
				!this.isOpen ||
				!this.$breakpoint('md')
			) {
				this.destroyPopper()
				return
			}
			if (!this.popper)
				this.popper = createPopper(this.$refs.button, this.$refs.menu, {
					placement: this.align
				})
		},
		destroyPopper() {
			this.popper?.destroy()
			this.popper = null
		},
		closeOnEscape(event) {
			if (!this.isOpen) return
			event.preventDefault()
			event.stopPropagation()
			this.close()
			this.$refs.button?.querySelector('button, a, [tabindex]')?.focus()
		},
		toggle() {
			this.isOpen = !this.isOpen
			this.$emit('dropdownIsOpen', this.isOpen)
		},

		open() {
			this.isOpen = true
			this.$emit('dropdownIsOpen', this.isOpen)
		},

		close() {
			this.isOpen = false
			this.$emit('dropdownIsOpen', this.isOpen)
		},

		dropdownItemClicked(event) {
			if (event.target.closest('.dropdown-item')) {
				this.close()
			}
		}
	},
	watch: {
		isOpen() {
			this.$nextTick(this.syncPopper)
		}
	}
}
</script>
